<template>
    <div id="filter-location-component">
        <span class="selectwrap filer-box-location">
                                    <select v-model="filterLocation">
                                        <option value="">All locations</option>
                                        <option v-for="location in storeLocations"
                                                :value="location._id">{{location.name}}</option>
                                    </select>
                                </span>
        <span class="selectwrap filer-box-location">
                                    <select v-model="filterStaff">
                                        <option value="">All physicians</option>
                                        <option v-for="staff in storeStaffs"
                                                v-show="checkShowStaff(staff)"
                                                :value="staff._id">{{staff.fullName}}</option>
                                    </select>
                                </span>

    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped="">
    .filer-box-location {
        float: left;
        width: 50%;
    }
</style>

<script>
import Multiselect from 'vue-multiselect'
import config from '../config'
import { mapGetters } from 'vuex'

export default {
  name: 'FilterLocation',
  props: {},

  components: {},
  data () {
    return {
      filterStaff: '',
      filterLocation: ''
    }
  },
  computed: {
    ...mapGetters({
      storeLocations: 'locations',
      storeStaffs: 'staffs',
      storeSelectedLocation: 'selectedLocation',
      storeSelectedStaff: 'selectedStaff'
    })
  },
  watch: {
    storeSelectedLocation (newVal, oldVal) {
      this.filterLocation = newVal
    },
    storeSelectedStaff (newVal, oldVal) {
      this.filterStaff = newVal
    },
    filterLocation (newVal, oldVal) {
      this.emitNewDataFilter()
    },
    filterStaff (newVal, oldVal) {
      this.emitNewDataFilter()
    }
  },
  mounted () {
    //      this.filterLocation = this.storeSelectedLocation
    //      this.filterStaff = this.storeSelectedStaff
  },
  methods: {
    checkShowStaff (staff) {
      if (this.filterLocation) {
        let index = this.storeLocations.findIndex(l => l._id == this.filterLocation)
        if (index > -1) {
          if (staff.clinicIdWiki === this.storeLocations[index].clinicIdWiki) {
            return true
          }
        }
        return false
      }
      return true
    },
    emitNewDataFilter () {
      let data = {
        location: {
          _id: '',
          name: '',
          idWiki: 0
        },
        staff: {
          _id: '',
          name: '',
          idWiki: 0
        }
      }
      if (this.filterLocation) {
        let index = this.storeLocations.findIndex(l => l._id == this.filterLocation)
        if (index > -1) {
          data.location = this.storeLocations[index]
        }
      }
      if (this.filterStaff) {
        let index = this.storeStaffs.findIndex(l => l._id == this.filterStaff)
        if (index > -1) {
          data.staff = this.storeStaffs[index]
        }
      }
      this.$emit('updateFilter', data)
    }
  },
  updated () {

  }

}
</script>
